import React, { useEffect, useState } from "react";
import { Col, Row, Space, Typography, Table } from "antd";
import { optionsTypeLens } from "types/config/glasses-prescription ";
import { GlassesPrescriptionColumns, data4Col } from "./config";
import { checkEmptyObj } from "helper/common";

const GlassesPrescriptionPrint = ({ detailPhieu }) => {
  const [dataGlassesPrescriptionPrint, setDataGlassesPrescriptionPrint] =
    useState({
      left: data4Col,
      right: data4Col,
    });

  useEffect(() => {
    if (
      detailPhieu &&
      detailPhieu?.left &&
      (detailPhieu?.left?.tb1?.sph ||
        detailPhieu?.left?.tb1?.cyl ||
        detailPhieu?.left?.tb1?.axis ||
        detailPhieu?.left?.tb1?.vision)
    ) {
      setDataGlassesPrescriptionPrint((pre) => ({
        ...dataGlassesPrescriptionPrint,
        left: [
          {
            key: 1,
            none: "Xa",
            sph: detailPhieu?.left?.tb1?.sph && detailPhieu?.left?.tb1?.sph[0],
            cyl: detailPhieu?.left?.tb1?.cyl && detailPhieu?.left?.tb1?.cyl[0],
            axis:
              detailPhieu?.left?.tb1?.axis && detailPhieu?.left?.tb1?.axis[0],
            vision:
              detailPhieu?.left?.tb1?.vision &&
              detailPhieu?.left?.tb1?.vision[0],
          },
          {
            key: 2,
            none: "Add",
            sph: detailPhieu?.left?.tb1?.sph && detailPhieu?.left?.tb1?.sph[1],
            cyl: detailPhieu?.left?.tb1?.cyl && detailPhieu?.left?.tb1?.cyl[1],
            axis:
              detailPhieu?.left?.tb1?.axis && detailPhieu?.left?.tb1?.axis[1],
            vision:
              detailPhieu?.left?.tb1?.vision &&
              detailPhieu?.left?.tb1?.vision[1],
          },
          {
            key: 3,
            none: "Gần",
            sph: detailPhieu?.left?.tb1?.sph && detailPhieu?.left?.tb1?.sph[2],
            cyl: detailPhieu?.left?.tb1?.cyl && detailPhieu?.left?.tb1?.cyl[2],
            axis:
              detailPhieu?.left?.tb1?.axis && detailPhieu?.left?.tb1?.axis[2],
            vision:
              detailPhieu?.left?.tb1?.vision &&
              detailPhieu?.left?.tb1?.vision[2],
          },
        ],
      }));
    }
    if (
      detailPhieu &&
      detailPhieu?.right &&
      (detailPhieu?.right?.tb1?.sph ||
        detailPhieu?.right?.tb1?.cyl ||
        detailPhieu?.right?.tb1?.axis ||
        detailPhieu?.right?.tb1?.vision)
    ) {
      setDataGlassesPrescriptionPrint((pre) => ({
        ...pre,
        right: [
          {
            key: 1,
            none: "Xa",
            sph:
              detailPhieu?.right?.tb1?.sph && detailPhieu?.right?.tb1?.sph[0],
            cyl:
              detailPhieu?.right?.tb1?.cyl && detailPhieu?.right?.tb1?.cyl[0],
            axis:
              detailPhieu?.right?.tb1?.axis && detailPhieu?.right?.tb1?.axis[0],
            vision:
              detailPhieu?.right?.tb1?.vision &&
              detailPhieu?.right?.tb1?.vision[0],
          },
          {
            key: 2,
            none: "Add",
            sph:
              detailPhieu?.right?.tb1?.sph && detailPhieu?.right?.tb1?.sph[1],
            cyl:
              detailPhieu?.right?.tb1?.cyl && detailPhieu?.right?.tb1?.cyl[1],
            axis:
              detailPhieu?.right?.tb1?.axis && detailPhieu?.right?.tb1?.axis[1],
            vision:
              detailPhieu?.right?.tb1?.vision &&
              detailPhieu?.right?.tb1?.vision[1],
          },
          {
            key: 3,
            none: "Gần",
            sph:
              detailPhieu?.right?.tb1?.sph && detailPhieu?.right?.tb1?.sph[2],
            cyl:
              detailPhieu?.right?.tb1?.cyl && detailPhieu?.right?.tb1?.cyl[2],
            axis:
              detailPhieu?.right?.tb1?.axis && detailPhieu?.right?.tb1?.axis[2],
            vision:
              detailPhieu?.right?.tb1?.vision &&
              detailPhieu?.right?.tb1?.vision[2],
          },
        ],
      }));
    }
  }, [detailPhieu]);

  const value = [
    {
      key: 1,
      data: dataGlassesPrescriptionPrint.right || [],
      mpd: detailPhieu?.right?.tb2 && detailPhieu?.right?.tb2.mpd,
      typeOfLens: detailPhieu?.right?.tb2 && detailPhieu?.right?.tb2?.lensType,
      advice: detailPhieu?.right?.tb2 && detailPhieu?.right?.tb2?.advice,
    },
    {
      key: 2,
      data: dataGlassesPrescriptionPrint.left || [],
      mpd: detailPhieu?.left?.tb2 && detailPhieu?.left?.tb2?.mpd,
      typeOfLens: detailPhieu?.left?.tb2 && detailPhieu?.left?.tb2?.lensType,
      advice: detailPhieu?.left?.tb2 && detailPhieu?.left?.tb2?.advice,
    },
  ];
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Row gutter={8}>
        {value.map((item) => {
          const typeOfLens = optionsTypeLens.find((e) => {
            if (e.value === item.typeOfLens) {
              return e.label;
            }
          });
          return (
            <Col span={12} key={item.key}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Typography.Text style={{ fontWeight: "bold" }}>
                  Đơn kính:
                </Typography.Text>
                <Table
                  dataSource={item.data}
                  columns={GlassesPrescriptionColumns}
                  bordered={true}
                  pagination={false}
                  className="table-print"
                />
                {item?.typeOfLens && (
                  <Row>
                    <Typography
                      style={{ fontWeight: "bold", paddingRight: "5px" }}
                    >
                      Loại mắt kính:
                    </Typography>
                    <Typography.Text>{typeOfLens?.label}</Typography.Text>
                  </Row>
                )}
                {item?.mpd && (
                  <Row>
                    <Typography
                      style={{ fontWeight: "bold", paddingRight: "5px" }}
                    >
                      MPD:
                    </Typography>
                    <Typography.Text>{item.mpd} mm</Typography.Text>
                  </Row>
                )}
                {item?.advice && (
                  <Row>
                    <Typography
                      style={{ fontWeight: "bold", paddingRight: "5px" }}
                    >
                      Lời khuyên:
                    </Typography>
                    <Typography.Text>{item?.advice}</Typography.Text>
                  </Row>
                )}
              </Space>
            </Col>
          );
        })}
      </Row>
    </Space>
  );
};

export default GlassesPrescriptionPrint;
